import { Buildings, SignOut, Storefront } from '@phosphor-icons/react'
import { useState } from 'react'
import { request } from '../api/client'

export function StoreSetup({ canCreate, onComplete, onLogout }: {
  canCreate: boolean
  onComplete: () => Promise<void>
  onLogout: () => Promise<void>
}) {
  const [name, setName] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState('')
  const submit = async () => {
    if (!name.trim()) return setError('请输入首家门店名称')
    setSubmitting(true); setError('')
    try {
      await request({ url: '/luxury/location/create', method: 'POST', data: {
        requestId: crypto.randomUUID(), type: 'STORE', fullName: name.trim(), shortName: name.trim(),
        visibilityType: 'ALL', firstArea: { name: '默认区', sort: 1 },
      } })
      await onComplete()
    } catch (reason) { setError(reason instanceof Error ? reason.message : '创建失败') }
    finally { setSubmitting(false) }
  }
  return <div className="setup-page">
    <section>
      <img src="/assets/lekeshe-logo.png" alt="乐客奢" />
      <small>首次使用</small><h1>先创建第一家门店</h1>
      <p>门店会成为库存、订单、客户权限和经营统计的基础范围。</p>
      {canCreate ? <><label>门店名称<input value={name} onChange={(event) => setName(event.target.value)} placeholder="例如：上海静安店" /></label>{error && <div className="form-error">{error}</div>}<button className="primary-button" disabled={submitting} onClick={submit}><Storefront />{submitting ? '正在创建' : '创建门店并进入'}</button></> : <div className="empty-permission"><Buildings /><strong>尚未配置门店</strong><span>请联系租户管理员完成首店初始化。</span></div>}
      <button className="setup-logout" onClick={() => void onLogout()}><SignOut />退出当前账号</button>
    </section>
  </div>
}
